import { AvailableProduct, CreditCard } from "./model";
import { createAction, props } from "@ngrx/store";
import { createApiActions } from "@store/api-action";
import { AuthenticateResultModel } from "../../../api/proxies";

export const loadCustomerPaymentInfoAction = createApiActions("[OrderBump] loadCustomerPaymentInfoAction", "OrderBump", {
    errorConfig: props<{ error: any }>(),
    completeConfig: props<{ info: CreditCard }>(),
});

export const setCreditCard = createAction("[OrderBump] setCreditCard", props<{ creditCard: CreditCard }>());

export const createOrderAction = createApiActions("[OrderBump] createOrderAction", "OrderBump", {
    clientConfig: props<{ paymentMethod: number, numberOfInstallments: number, creditCard: CreditCard, discountVoucher: string | undefined, products: AvailableProduct[] }>(),
    errorConfig: props<{ error: any }>(),
});

export const cancel = createAction("[OrderBump] cancel");

export const createOrderCanceled = createAction(
    "[OrderBump] canceled",
    props<{
        authenticateResultModel: AuthenticateResultModel
    }>()
);

export const createOrderCompleted = createAction(
    "[Subscription] createOrderCompleted",
    props<{
        authenticateResultModel: AuthenticateResultModel
    }>()
);

export const loadAvailableAdditionalProducts = createAction("[OrderBump] loadAvailableAdditionalProducts");

export const loadAvailableAdditionalProductsComplete = createAction(
    "[OrderBump] loadAvailableAdditionalProductsComplete",
    props<{ products: AvailableProduct[] }>()
);

export const loadAvailableAdditionalProductsError = createAction(
    "[OrderBump] loadAvailableAdditionalProductsError",
    props<{ error: any }>()
);
